module.exports = __webpack_public_path__ + "img/analytics_bolt.10881d2.svg";